import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { useAuthentication } from 'authentication/context'
import { ActivateScreenProps } from 'onboarding/stack/types'
import ActivateView from 'onboarding/views/activate'
import React, { useCallback, useLayoutEffect, useState } from 'react'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderButton } from 'shared/header/header_button'

export function ActivateScreen({ navigation, route }: ActivateScreenProps) {
  const [isLoading, setLoading] = useState(false)
  const [error, setError] = useState(undefined)
  const [code, setCode] = useState('')
  const { login, setProfileNeedsReview } = useAuthentication()
  const { phoneNumber, profileNeedsReview } = route.params
  const { theme } = useTheme()

  const onSubmit = useCallback(async () => {
    if (!login) {
      return
    }

    try {
      setLoading(true)
      await login(phoneNumber, code)
      setProfileNeedsReview(profileNeedsReview)
    } catch (err: any) {
      setError(err)
      setLoading(false)
    }
  }, [code, login, phoneNumber, profileNeedsReview, setProfileNeedsReview])

  useLayoutEffect(() => {
    showHeaderButton({
      navigation,
      theme,
      title: t('signIn'),
      onPress: onSubmit,
      position: 'right',
      useIcon: false,
      disabled: !code,
    })
  }, [code, navigation, onSubmit, phoneNumber, theme])

  return (
    <StatusBoundary
      isLoading={isLoading}
      loadingMessage={t('activating')}
      error={undefined}
    >
      <ActivateView
        {...{ phoneNumber, isLoading, error, code, setCode, onSubmit }}
      />
    </StatusBoundary>
  )
}
